var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c("div", { staticClass: "mb20" }, [
            _c("h3", [_vm._v("系统缓存清理")]),
            _vm._v(" "),
            _c("p", { staticClass: "text-muted" }, [
              _vm._v("清除后端系统配置缓存，提升系统性能"),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "hasPermi",
                  rawName: "v-hasPermi",
                  value: ["admin:system:config:clear:cache"],
                  expression: "['admin:system:config:clear:cache']",
                },
                {
                  name: "debounceClick",
                  rawName: "v-debounceClick",
                  value: _vm.handleClear,
                  expression: "handleClear",
                },
              ],
              attrs: {
                type: "primary",
                size: "small",
                loading: _vm.systemCacheLoading,
              },
            },
            [_vm._v("清除系统缓存")]
          ),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c("div", { staticClass: "mb20" }, [
            _c("h3", [_vm._v("浏览器缓存清理")]),
            _vm._v(" "),
            _c("p", { staticClass: "text-muted" }, [
              _vm._v("清理浏览器本地存储缓存，解决页面显示异常问题"),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "hasPermi",
                  rawName: "v-hasPermi",
                  value: ["admin:system:cache:clear:browser"],
                  expression: "['admin:system:cache:clear:browser']",
                },
                {
                  name: "debounceClick",
                  rawName: "v-debounceClick",
                  value: _vm.handleClearBrowserCache,
                  expression: "handleClearBrowserCache",
                },
              ],
              attrs: {
                type: "warning",
                size: "small",
                loading: _vm.browserCacheLoading,
              },
            },
            [_vm._v("清除浏览器缓存")]
          ),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c("div", { staticClass: "mb20" }, [
            _c("h3", [_vm._v("缓存状态信息")]),
            _vm._v(" "),
            _c("p", { staticClass: "text-muted" }, [
              _vm._v("查看当前缓存状态和清理记录"),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cache-info" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("应用版本："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.appVersion)),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("最后清理："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.lastClearTime)),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("存储使用："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.storageUsage)),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }